import React, { Component, createRef } from "react";
import { TouchableOpacity } from "react-native";

import { FILE_TYPE, MAX_FILE_SIZE } from "consts";

export class FilePicker extends Component {
  input = createRef();

  onPress = () => {
    this.input.current?.click();
  };

  readFile = e => {
    const files = e.target.files;
    for (let i = 0, numFiles = files.length; i < numFiles; i++) {
      const file = files[i];
      const type = imageTypes.includes(file.type)
        ? FILE_TYPE.IMAGE
        : FILE_TYPE.VIDEO;
      const fileURL = window.URL.createObjectURL(file);
      // const uri = file.size > MAX_FILE_SIZE ? "" : fileURL;
      const uri = fileURL;
      this.props.onCapture(uri, type);
    }
  };

  render = () => {
    const { photo, video } = this.props;
    const acceptType =
      photo && video ? "image/*|video/*" : video ? "video/*" : "image/*";

    return (
      <TouchableOpacity onPress={this.onPress}>
        {this.props.children}
        <input
          ref={this.input}
          style={style}
          accept={acceptType}
          type="file"
          onChange={this.readFile}
        />
      </TouchableOpacity>
    );
  };
}

const style = { display: "none" };

const imageTypes = ["image/gif", "image/jpg", "image/jpeg", "image/png"];
